import { useQuery } from 'react-query'
import { useParams, useSearchParams } from 'react-router-dom'

import ProductService from 'src/services/product.service'

import { QUERY_KEYS } from 'src/constants'

const useProduct = (locale: string) => {
  const { id } = useParams()
  const [searchParams] = useSearchParams()
  const duplicate = searchParams.get('duplicate')

  return useQuery(
    [QUERY_KEYS.GET_PRODUCT, id ?? duplicate ?? '', locale],
    async () => {
      return await ProductService.getProductById(id || duplicate!, locale)
    },
    {
      refetchOnWindowFocus: false,
      keepPreviousData: true,
      enabled: !!id || !!duplicate,
      refetchInterval: (data) => (data?.is_minting ? 6000 : false),
    },
  )
}

export { useProduct }
